module.exports = __webpack_public_path__ + "static/media/ic-search-old.c581df96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-search-old.svg
// module id = 659
// module chunks = 14